module.exports = __webpack_public_path__ + "img/0f5c271.svg";